<template>
  <sea-page-content
    :fetchList="fetchList"
    :resetList="resetList"
    searchPanel
    toolbar
    searchType="data"

    pulsanteAggiorna
    pulsante-aggiorna
    showCompanyHeader
    pulsante-elimina
    :pulsanteEliminaDisabled="false"
  >
    <template v-slot:form>
      <v-alert type="warning" v-model="alert" dismissible>
        {{ text }}
      </v-alert>
      <form name="form" role="form" @submit.prevent="save()">
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols="12" lg="3">
                <v-select
                  :items="tipiRichiesta"
                  v-model="$v.editedItem.tipo.$model"
                  label="Tipo richiesta"
                  :error-messages="errors('tipo')"
                  @input="$v.editedItem.tipo.$touch()"
                  @blur="$v.editedItem.tipo.$touch()"
                  @change="setFields"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" lg="5">
                <v-textarea
                  v-model="editedItem.testo"
                  label="Testo"
                  rows="1"
                  outlined
                  :disabled="textareaDisabled"
                ></v-textarea>
              </v-col>
              <v-col cols="12" lg="4">
                <v-file-input v-model="file" label="Allega"></v-file-input>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              color="blue darken-1"
              text
              :disabled="$v.editedItem.$invalid"
            >
              Invia richiesta
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </template>
    <v-divider></v-divider>
    <template v-slot:table="{ attrs }">
      <v-data-table
        v-model="attrs.selected"
        v-bind="attrs"
        :items="items"
        :headers="headers"
        disable-sort
        dense
        height="calc(100vh - 475px)"
        :expanded="expanded"
        item-key="id"
        @click:row="clicked"
        show-select
      >
        <template v-slot:item.data="{ item }">
          {{ item.data | dateFormat }}
        </template>
        <template v-slot:item.tipo="{ item }">
          {{
            item.tipo &&
              tipiRichiesta.find((el) => el.value === item.tipo) &&
              tipiRichiesta.find((el) => el.value === item.tipo).text
          }}
        </template>
        <template v-slot:item.stato="{ item }">
          {{
            item.stato &&
              statiRichiesta.find((el) => el.value === item.stato) &&
              statiRichiesta.find((el) => el.value === item.stato).text
          }}
        </template>
        <template v-slot:item.testo="{ item }">
          <div class="text-truncate" style="width: 150px">
            {{ item.testo }}
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            elevation="2"
            rounded
            x-small
            color="primary"
            @click.stop="clicked(item)"
          >
            Dettaglio
            <v-icon right dark>mdi-cloud-download </v-icon>
          </v-btn>
          <v-btn
            :disabled="!item.hasDoc"
            elevation="2"
            rounded
            x-small
            color="primary"
            @click.stop="download(item)"

          >
            Apri
            <v-icon right dark>mdi-cloud-download </v-icon>
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <div class="d-flex justify-center" style="width: 100%">
              <div style="width: 67vw">
                {{ item.testo }}
              </div>
            </div>
          </td>
        </template>
      </v-data-table>
    </template>
  </sea-page-content>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { tipiRichiesta, statiRichiesta } from "@/constants";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import mixin from "@/mixin";
import { MAX_FILE_SIZE } from "@/constants";

const headers = [
  { text: "Data", value: "data", class: ["heading"] },
  { text: "Tipo richiesta", value: "tipo", class: ["heading"] },
  { text: "Descrizione", value: "testo", class: ["heading"] },
  { text: "Stato richiesta", value: "stato", class: ["heading"] },
  { text: "", value: "actions", align: "end", class: ["heading"] },
];

export default {
  mixins: [validationMixin, mixin],
  validations() {
    return {
      editedItem: {
        tipo: {
          required,
        },
      },
    };
  },
  mounted() {
    this.resetCurrent();
  },
  data() {
    return {
      expanded: [],
      alert: false,
      text: "",
      textareaDisabled: false,
      file: null,
      tipiRichiesta,
      statiRichiesta,
      headers,
    };
  },
  methods: {
    ...mapActions({
      resetCurrent: "docsAzi/resetCurrentRequest",
      fetchList: "docsAzi/fetchRequestsAzi",
      resetList: "docsAzi/resetRequests",
      create: "docsAzi/createRequest",
      download: "docsAzi/downloadRequest",
    }),
    cronologia(id) {
      this.$router.push(`/documents/dossierHistory/${id}`);
    },
    clicked(value) {
      const index = this.expanded.indexOf(value);
      if (index === -1) {
        this.expanded.length = 0;
        this.expanded.push(value);
      } else {
        this.expanded.splice(index, 1);
      }
    },
    async save() {
      this.$v.$touch();

      if (!this.$v.editedItem.$invalid && this.check()) {
        await this.create({ request: this.editedItem, file: this.file });
        await this.resetCurrent();
        this.$v.$reset();
        this.file = null;
        this.fetchList({ da: "", a: "" }).then(() => (this.myLoading = false));
      }
    },

    check() {
      if (this.file && this.file.size > MAX_FILE_SIZE) {
        this.text = this.locales.fileSize;
        this.alert = true;
        setTimeout(() => (this.alert = false), 5000);
        return false;
      }
      switch (this.editedItem.tipo) {
        case 1:
        case 2:
          if (!this.file) {
            this.openAlert(this.editedItem.tipo);
            return false;
          }
          break;
        case 3:
        case 4:
          if (!this.editedItem.testo) {
            this.openAlert(this.editedItem.tipo);
            return false;
          }
          break;
        default:
          break;
      }
      return true;
    },
    openAlert(index) {
      this.text = this.tipiRichiesta.find((t) => t.value === index).error;
      this.alert = true;
      setTimeout(() => (this.alert = false), 5000);
    },
    setFields() {
      switch (this.editedItem.tipo) {
        case 1:
        case 2:
          this.textareaDisabled = true;
          this.editedItem.testo = "";
          break;
        default:
          this.textareaDisabled = false;
          break;
      }
    },
    errors(fieldName) {
      const errors = [];
      if (!this.$v.editedItem[fieldName].$dirty) return errors;
      if (fieldName === "tipo") {
        !this.$v.editedItem.tipo.required && errors.push(this.locales.required);
      }
      return errors;
    },
  },
  computed: {
    ...mapGetters({
      items: "docsAzi/requests",
      editedItem: "docsAzi/currentRequest",
    }),
  },
};
</script>

<style>
/** */
</style>
